import React from 'react';
import './FreeShippingHeader.css';

const FreeShippingHeader = () => {
  return (
    <header className="free-shipping-header">
      <h1 className="free-shipping-text">Envíos gratis por pedidos superiores a $50.000</h1>
    </header>
  );
};

export default FreeShippingHeader;
